<script>
  export default {
    props: {
      variant: {
        type: [
          String, 'primary', 'secondary',
        ],
        required: false,
        default: 'primary',
      },
    },

    computed: {
      text () {
        const {
          variant,
        } = this;

        if (variant === 'primary') {
          return 'Ambiente seguro e autenticado';
        }

        return 'Suas informações 100% seguras';
      },
    },
  };
</script>

<template>
  <div
    class="bdk-flex bdk-items-center"
  >
    <div
      class="bdk-appearance-none bdk-space-x-2 bdk-border-0 bdk-p-2 sm:bdk-py-1 sm:bdk-px-2 bdk-leading-tight bdk-rounded bdk-bg-gray-50 hover:bdk-bg-gray-100 bdk-text-gray-600 bdk-text-xs bdk-font-bold bdk-flex bdk-items-center bdk-cursor-pointer focus:bdk-outline-none bdk-ring-0 bdk-focus:ring-2 bdk-ring-gray-600 bdk-ring-opacity-40"
    >
      <svg v-if="variant === 'primary'" fill="currentColor" viewBox="0 0 20 20" class="bdk-w-4 bdk-h-4"><path fill-rule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clip-rule="evenodd"></path></svg>

      <svg v-else class="bdk-w-4 bdk-h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" /></svg>

      <span
        v-text="__(text)"
        class="bdk-text-xs sm:bdk-inline-flex bdk-uppercase"
      />
    </div>
  </div>
</template>
